module.exports = __webpack_public_path__ + "static/logo-ms-29febaec8c2c11f7cf30a73e601a2896.png";